import { css } from "@emotion/css";
import { PropsOf } from "@emotion/react";
import { Modal as AriaModal } from "react-aria-components";

import { _Modal } from "./assets/_Modal";
import { _ModalOverlay } from "./assets/_ModalOverlay";

interface Props extends PropsOf<typeof AriaModal> {
  scroll?: "viewport" | "body";
  testID?: string;
}

export function Modal(props: Props) {
  const { scroll, testID = "modal", ...modalProps } = props;

  return (
    <_ModalOverlay
      className={styles.overlay}
      isDismissable={props.isDismissable}
      isKeyboardDismissDisabled={props.isKeyboardDismissDisabled}
      isEntering={props.isEntering}
      isExiting={props.isExiting}
      isOpen={props.isOpen}
      scroll={scroll}
      data-testid={`${testID}-overlay`}
    >
      <_Modal {...modalProps} data-testid={testID} />
    </_ModalOverlay>
  );
}

const styles = {
  overlay: css({ zIndex: 100 }),
};
